import { GET_ALL_STATICS, GetAllStatics } from "../types/statics";

export const getAllStatics = (callback?: () => void): GetAllStatics => ({
  type: GET_ALL_STATICS, 
  payload: {callback}
});
